(function () {
    'use strict';

    angular.module('thankview.global')
        .directive('tvOverlay', ['$document', '$timeout', 'transition', '$window', function ($document, $timeout, transition, $window) {
            return {
                restrict: 'A',
                link: function (scope, element) {
                    let overlay;
                    let backdrop;
                    scope.isScopeClose = false; // boolean flag for if we're calling close within Angular scope or not

                    // Some close handlers overlays need

                    // prevent clicks on backdrop from closing overlay
                    // more ideally we'd just not include the hide attribute but we tend to set
                    // dontClose dynamically so instead we'll just re-show the dialog
                    const dontHide = function (el, event) {
                        if (!event) return;
                        if (event.currentTarget === backdrop) {
                            overlay.show();
                        }
                    };

                    /**
                     * Default event handler for a11y dialog hide
                     * @param {Boolean} scopeCall - if the function is called from Angualr scope or not
                     */
                    scope.notifyClose = function () {
                        scope.$emit('close-overlay');
                        if (scope.fixBody) {
                            angular.element($document[0].body).removeClass('modal-open');
                        }
                        // when calling this from outside angular, we have to manually call scope.$apply
                        if (!scope.isScopeClose) {
                            scope.$apply();
                        }
                    };

                    // register our overlay with a11y-dialog to hook up its functionality
                    scope.init = function () {
                        overlay = new $window.A11yDialog(element[0]);
                        backdrop = element[0].querySelector('div[data-a11y-dialog-hide]');
                        overlay.on('hide', scope.notifyClose);
                    };

                    scope.open = function () {
                        if (scope.dontClose) {
                            element.addClass('dont-close');
                            element.attr('role', 'alertdialog'); // signal to a11y modal to not close this when pressing esc
                            overlay.on('hide', dontHide);
                        }
                        element[0].scrollTop = 0;
                        if (scope.fixBody) {
                            angular.element($document[0].body).addClass('modal-open');
                        }
                        // reset close boolean flag
                        scope.isScopeClose = false;
                        overlay.show();
                    };

                    // this could theoretically be replaced with a11y dialog defaults
                    // but leaving this here was a bit easier to refactor all the existing overlays
                    scope.close = function ($event) {
                        if ($event) {
                            $event.preventDefault();
                        }
                        scope.isScopeClose = true;
                        overlay.hide();
                    };

                    scope.$on('open-overlay', scope.open);
                    scope.$on('force-close-overlay', scope.close);

                    scope.init();
                },
            };
        }]);
}());
